import { saveAs } from 'file-saver/FileSaver'
import moment from 'moment'
import { URL } from '../../../../../config'
import { getRequest } from '../../../../../utils/httpRequest'

export default function (eventId, eventname, startdate,enddate, _this){
    const  eventURL = URL.event
    const url = `${eventURL}/${eventId}/template`
    const request = getRequest(url,'arraybuffer')
    request.then(function(response) {
       
         return new Blob([response.data],{ type: 'application/vnd.ms-excel.sheet.macroEnabled.12' })
     })
     .then(function(blob){
         saveAs(blob,`${eventname} - ${moment(startdate).format('LL')} through ${moment(enddate).format('LL')}.xlsm`,{ type:'application/vnd.ms-excel.sheet.macroEnabled.12' })
         _this.setState({ generatingTemplate:false })
    })
  
 }


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/EventTemplate/Logic/downloadTemplate.js